import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Container, makeStyles} from '@material-ui/core';
import {SecondaryNavigation} from '../Navigation';
import ClassroomAdminReadingNightsList from './ClassroomAdminReadingNightsList';
import {addFlashMessage} from 'actions/flash-message';
import {formatErrors} from 'actions/errors';
import {isKluwellAdmin} from 'utils/permissions';

const useStyles = makeStyles(({spacing}) => ({
  root: {
    marginTop: spacing(2),
  },
}));

const ClassroomAdmin = ({
  me,
  match: {
    params: {classroomId},
  },
}) => {
  const classes = useStyles();
  return (
    <React.Fragment>
      <SecondaryNavigation
        tabs={[
          {url: `/classrooms/${classroomId}`, label: 'Classroom Detail', isActive: false},
          {
            url: `/classrooms/${classroomId}/bulk-create-students`,
            label: 'Bulk Create Students',
            isActive: false,
          },
          ['kluwell_admin', 'teacher', 'school_coordinator'].includes(me.role) && {
            url: `/classrooms/${classroomId}/admin`,
            label: 'Student Reading Nights',
            isActive: true,
          },
        ].filter((v) => v)}
        hasBack
      />
      <ClassroomAdminReadingNightsList classroomId={classroomId} />
    </React.Fragment>
  );
};

ClassroomAdmin.propTypes = {
  me: PropTypes.object.isRequired,
};

export default connect(
  ({account}) => ({
    me: account.get('user').toJS(),
  }),
  {
    addFlashMessage,
    formatErrors,
  },
)(ClassroomAdmin);
